import React, { useEffect } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { IN_ROOM_DINING_CATEGORY_EDIT } from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { PARTIAL_CHECKBOX_GREEN, updateSelectedModule } from '../../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';

const CategoryListTable = (props) => {
  const {
    categoryList,
    dragDisabled,
    selectedCategoryLength,
    page,
    rowsPerPage,
    handleCellMenuClick,
    selectedValue,
    handleClose,
    onActiveDeActiveCategoty,
    onClickRowViewDetails,
    onViewDetails,
    onDeleteCategory,
    handleChangePage,
    handleChangeRowsPerPage,
    onOpenDrawer,
    permissions,
    setVisible,
    setCategoryList,
    searchText,
    handleSelectAll,
    isAllSelected,
    setIsAllSelected,
    handleCheckboxChange,
    setActionMenuList,
    inRoomDiningCategory,
  } = props;

  useEffect(() => {
    updateSelectedModule(categoryList, setActionMenuList, setIsAllSelected);
  }, [categoryList]);

  return (
    <TableContainer>
      <Table className='list-table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
              <BulkActionCheckBox
                onChange={handleSelectAll}
                checked={isAllSelected || false}
                selectedLength={selectedCategoryLength}
                totalLength={inRoomDiningCategory?.length}
                inputProps={{
                  'aria-label': 'select all categories',
                }}
                className={PARTIAL_CHECKBOX_GREEN}
              />
            </TableCell>
            <TableCell className='w-70'>Name</TableCell>
            <TableCell className='w-20' align='center'>
              Status
            </TableCell>
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>

        <DragDropContext
          onDragEnd={(event) =>
            handleOnDragEnd(
              event,
              setVisible,
              categoryList,
              setCategoryList,
              false,
              page,
              rowsPerPage,
            )
          }
          isDropDisabled={dragDisabled}
        >
          <Droppable droppableId='services' isDropDisabled={dragDisabled}>
            {(provided) => (
              <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                {(rowsPerPage > 0
                  ? categoryList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : categoryList
                ).map((categoryKey, key) => (
                  <Draggable
                    key={categoryKey.id}
                    draggableId={categoryKey.id}
                    index={key}
                    isDragDisabled={dragDisabled}
                  >
                    {(provided) => (
                      <TableRow
                        key={key}
                        className='border-white pointer'
                        onClick={(e) => {
                          onClickRowViewDetails(categoryKey, e);
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <TableCell className='w-12'>
                          {!dragDisabled && (
                            <span style={{ marginRight: 1.5 }}>
                              <DragIndicator className='res-menu-accordion-drag' />
                            </span>
                          )}
                          <Checkbox
                            onChange={(event) => handleCheckboxChange(categoryKey?.id)}
                            checked={categoryKey?.isChecked || false}
                            inputProps={{
                              'aria-label': `select category ${categoryKey?.id}`,
                            }}
                          />
                        </TableCell>
                        <TableCell className='w-70'>{categoryKey?.name}</TableCell>
                        <TableCell className='w-20' align='center'>
                          <CustomChip
                            label={categoryKey?.status ? 'Active' : 'Inactive'}
                            color={categoryKey?.status ? 'primary' : 'default'}
                          />
                        </TableCell>
                        <TableCell align='right'>
                          {permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                            <Button
                              aria-controls='simple-menu'
                              aria-haspopup='true'
                              onClick={(e) => {
                                handleCellMenuClick(e, categoryKey);
                              }}
                              className='showpopupInner'
                            >
                              <MoreHoriz className='showpopupInner' />
                            </Button>
                          )}
                          <Menu
                            id={key}
                            anchorEl={selectedValue?.anchorEl}
                            disableRestoreFocus
                            MenuListProps={{ autoFocusItem: false }}
                            keepMounted
                            open={
                              Boolean(selectedValue?.anchorEl) &&
                              selectedValue?.id === categoryKey?.id
                            }
                            onClose={handleClose}
                            className='shadow'
                          >
                            <MenuItem
                              className='pe-4'
                              onClick={(e) =>
                                onActiveDeActiveCategoty(
                                  e,
                                  selectedValue?.category?.status ? 'deactivate' : 'active',
                                )
                              }
                            >
                              {selectedValue?.category?.status ? (
                                <>
                                  <RemoveCircle className='me-2 action-menu-icon' />
                                  Deactivate
                                </>
                              ) : (
                                <>
                                  <AddCircle className='me-2 action-menu-icon' />
                                  Activate
                                </>
                              )}
                            </MenuItem>
                            <MenuItem
                              className='pe-4'
                              onClick={(e) => onOpenDrawer(e, IN_ROOM_DINING_CATEGORY_EDIT)}
                            >
                              <CreateIcon className='me-2 action-menu-icon' />
                              Edit
                            </MenuItem>
                            <MenuItem
                              className='pe-4'
                              onClick={(e) => onViewDetails(categoryKey, e)}
                            >
                              <VisibilityIcon className='me-2 action-menu-icon' />
                              View
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onDeleteCategory(e)}>
                              <DeleteForeverIcon className='me-2 action-menu-icon' />
                              Delete
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </DragDropContext>
        <TableFooter>
          <TableRow className='paginator'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              count={categoryList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default CategoryListTable;
